import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextareaComponent } from "../../templates/template-textarea/template-textarea.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-b10",
  imports: [TemplateTextareaComponent],
  templateUrl: "./prefix-b10.component.html",
  styleUrl: "./prefix-b10.component.less",
})
export class PrefixB10Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 2000;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["b10"];
  }
}
